import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { fadeIn, staggerContainer } from '../utils/motion'
import { ArrowBack } from '@mui/icons-material'

const Payment =({ cartTotal, cartItems, handlePayment, formError, setForm, form, handleChange })=>{
  return(
    <div>
      <form className='flex flex-col p-2 space-y-2'>
        <div className='flex space-x-2 justify-between mb-8'>
          <input value={form.name} onChange={handleChange} style={{ border:`solid ${formError && form.name === '' ? '2px' : '1px'} ${formError && form.name === '' ? 'red' : 'gray'}` }} required className={`w-full p-2 ${formError && form.name === '' ? 'bg-red-100' : ''} rounded-lg`} name='name' type='text' placeholder='Name'/>
          <input value={form.email} onChange={handleChange} style={{ border:`solid ${formError && form.email === '' ? '2px' : '1px'} ${formError && form.email === '' ? 'red' : 'gray'}` }} required className={`w-full p-2 ${formError && form.email === '' ? 'bg-red-100' : ''} rounded-lg`} name='email' type='email' placeholder='Email'/>
        </div>
        <div className='flex justify-between items-center'>
          <p className='font-bold text-center '>Shipping info</p>
        </div>
        <div className='grid grid-cols-2 gap-2'> 
        <input value={form.address} onChange={handleChange} style={{ border:`solid ${formError && form.address === '' ? '2px' : '1px'} ${formError && form.address === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.address === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='address' type='text' placeholder='Address'/>
        <input value={form.city} onChange={handleChange} style={{ border:`solid ${formError && form.city === '' ? '2px' : '1px'} ${formError && form.city === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.city === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='city' type='text' placeholder='City'/>
        <input value={form.state} onChange={handleChange} style={{ border:`solid ${formError && form.state === '' ? '2px' : '1px'} ${formError && form.state === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.state === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='state' type='text' placeholder='State'/>
        <input value={form.zip_code} onChange={handleChange} style={{ border:`solid ${formError && form.zip_code === '' ? '2px' : '1px'} ${formError && form.zip_code === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.zip_code === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='zip_code' type='text' placeholder='Zip Code'/>
        </div>
      </form>
      {
        formError
         ?
          <div>
            <p className='text-red-600 font-semibold'>Please fill out all the fields</p>
          </div>
           :
            ''
      }
      <button onClick={handlePayment} className='font-bold bg-green-600 rounded-lg shadow-md mt-6 w-full text-white px-4 py-2'>Pay ${cartTotal}</button> 
    </div>
  )
}

const Checkout = ({ items, cartTotal, setCheckingOut, cartItems }) => {
  return(
    <div>
      <div className='space-y-4'>
        <div className='flex justify-between items-center'>
          <ArrowBack onClick={() => setCheckingOut(false)} className='cursor-pointer' fontSize='large'/>
          <p className='font-bold text-2xl text-center '>Order Summary</p>
        </div>
      {items.map((item, index) => (
        <div className='flex justify-between items-center'>
          <img style={{ width:'100px' }} className='rounded-lg shadow-lg' key={index} src={item.img} alt='cartItem'/>
          <p className='font-bold'>{item.name}</p>
            <div className='flex space-x-3 justify-center items-center'>
              <p className='font-bold'>x{item.quantity}</p>
            </div>
            <p className='font-bold text-green-600'>${(item.price * item.quantity).toFixed(2)}</p>
        </div>
      ))}
      <div className='flex flex-col space-y-1'>
        <p className='font-semibold'>Items: {cartItems}</p>
        <p className='font-semibold '>Total: <span className='text-green-600'>${(cartTotal)}</span></p>
      </div> 
      </div>
    </div>
  )
}

const CartContent = ({ items, cartItems, cartTotal, buttonAction, setCheckingOut}) => {
  return(
    <div>
      <div className='flex justify-between items-center p-4'>
      <p className='font-semibold'>Items: {cartItems}</p>
      <p className='font-semibold'>Total Amount: <span className='text-green-600'>${cartTotal}</span></p>
    </div>
      {items.length !== 0 ? 
      <div className='space-y-8'>
      {items.map((item, index) => (
        <div className='flex justify-between items-center'>
          <img style={{ width:'100px' }} className='rounded-lg shadow-lg' key={index} src={item.img} alt='cartItem'/>
            {/* <p className='font-bold'>{item.name}</p> */}
            <div className='flex space-x-3 justify-center items-center'>
              <p onClick={() => buttonAction('remove', item.id, item.quantity, '')}  className='buttons w-[2.5vw] cursor-pointer rounded-lg py-1 text-center font-bold '>-</p>
              <p>{item.quantity}</p>
              <p onClick={() => buttonAction('add', item.id, item.quantity, '')}  className='buttons w-[2.5vw] cursor-pointer rounded-lg py-1 text-center font-bold '>+</p>
            </div>
            <p className='font-bold text-green-600'>${(item.price * item.quantity).toFixed(2)}</p>
        </div>
      ))}
      <button onClick={() => setCheckingOut(true)} className='font-bold bg-black mt-6 w-full text-white px-4 py-2'>Checkout</button>  
      </div>
      :
      <div>
        <p className='font-bold text-black text-2xl p-6 text-center'>No items in your cart yet</p>
      </div>} 
    </div>
  )
}

const Cart = ({ setCartVisible, buttonAction, items, setItems }) => {
  const [ checkingOut, setCheckingOut ] = useState(false)
  
  const cartItems = items.reduce((total, item)=> total + item.quantity, 0 )
  const cartTotal = items.reduce((total, item)=> total + item.quantity * item.price, 0 ).toFixed(2)

  const [form, setForm] = useState(
    {
      name:'',
      email:'',
      address:'',
      city:'',
      state:'',
      zip_code:''
    })
    const handleChange = (e) => {
      const { name, value } = e.target
      setForm({...form, [name]:value} )
    }
    const [ formError, setFormError ] = useState(false)


  function handlePayment (total){
    if(form.name === '' || form.email === '' || form.address === '' || form.city === '' || form.state === '' || form.zip_code === '' ){
      setFormError(true)
    }else{
      setItems([])
      setForm(
        {
          name:'',
          email:'',
          address:'',
          city:'',
          state:'',
          zip_code:''
        }
      )
      alert('Check out Succesful')
      setCartVisible(false)
    }
  }
  return (
    <motion.section
      variants={staggerContainer()}
      initial='hidden'
      whileInView={'show'}
      viewport={{ once:true, amount:0.25 }}>
        <motion.div variants={fadeIn('down', 'spring', 0.1,0.5)} className='cartWrapper absolute '>
          
            {
            checkingOut 
            ? 
            <div className='flex flex-col md:flex-row space-y-4 md:space-x-4 '>
            <div className='shadow-md bg-white p-4 md:rounded-lg   md:w-[35vw] md:min-h-[45vh] max-h-[53vh]'>
              <Payment 
              cartItems={cartItems}
              cartTotal={cartTotal}
              handlePayment={handlePayment}
              formError={formError}
              form={form}
              setForm={setForm}
              handleChange={handleChange}
              />  
            </div>
            <div className='shadow-md bg-white p-4 md:rounded-lg   md:w-[35vw]'>
              <Checkout
              items={items}
              setItems={setItems}
              cartItems={cartItems}
              cartTotal={cartTotal}
              setCheckingOut={setCheckingOut}
              /> 
            </div>
            </div>
            : 
            <div className='shadow-md bg-white p-4 md:rounded-lg  md:w-[35vw]'>

            <CartContent 
                items={items}
                setItems={setItems}
                cartItems={cartItems}
                cartTotal={cartTotal}
                buttonAction={buttonAction}
                setCheckingOut={setCheckingOut}
               />
               </div>
            }
        </motion.div>
    </motion.section>    
  )
}

export default Cart